import {useEffect, useReducer} from 'react';
import Form from 'react-bootstrap/Form';
import {HeaderTitle} from './HeaderTitle.jsx';
import PropTypes from 'prop-types';
import {Card, CardBody, CardHeader} from 'react-bootstrap';

const reducer = (state, action) => {
    switch (action.type) {
        case 'SET_OPTION': {
            const updatedList = state.checkList.map((check) =>
                check.nazwa === action.payload.nazwa ? {...check, selected: action.payload.selected} : check
            );
            return {...state, checkList: updatedList};
        }
        case 'SET_LIST': {
            return {
                checkList: action.payload,
            };
        }
        default:
            return state;
    }
};

export const CheckList = ({list, listName, size, nav, noHr, setState, parentName, initState, disabled}) => {
    const [state, dispatch] = useReducer(reducer, {
        checkList: initState?.checkList || list || [],
    });

    const handleOptionChange = (checkName, selectedOption) => {
        dispatch({type: 'SET_OPTION', payload: {nazwa: checkName, selected: selectedOption}});

        if (setState) {
            const updatedList = state.checkList.map((check) =>
                check.nazwa === checkName ? {...check, selected: selectedOption} : check
            );
            setState(updatedList);
        }
    };

    useEffect(() => {
        if (initState?.checkList) {
            dispatch({
                type: 'SET_LIST',
                payload: initState.checkList,
            });
        } else if (list) {
            dispatch({
                type: 'SET_LIST',
                payload: list,
            });
        }
    }, [list, initState?.checkList, parentName]);


    return (
        <Card className={'my-3'}>
            <CardHeader className={'px-2 py-0 m-0'}>
                <HeaderTitle
                    title={listName || 'Lista sprawdzająca'}
                    size={size || 'fs-6'}
                    nav={nav || false}
                    noHr={noHr || true}
                />
            </CardHeader>
            <CardBody>
                {state.checkList.map((check, index) => (
                    <div key={index} className="text-start d-flex flex-column mb-3 bg-light p-2">
                        <Form.Label column={'lg'}>{check.nazwa}</Form.Label>
                        <div className="d-flex gap-3 mb-3">
                            {['Tak', 'Nie', 'Nie dotyczy'].map((option) => {
                                    return <Form.Check
                                        key={option}
                                        disabled={disabled}
                                        type="radio"
                                        label={option}
                                        name={`${check.nazwa}-${index}`}
                                        checked={check.selected === option}
                                        onChange={() => handleOptionChange(check.nazwa, option)}
                                    />
                                }
                            )}
                        </div>
                    </div>
                ))}
            </CardBody>
        </Card>
    );
};

CheckList.propTypes = {
    listName: PropTypes.string,
    size: PropTypes.string,
    nav: PropTypes.bool,
    noHr: PropTypes.bool,
    setState: PropTypes.func,
    list: PropTypes.arrayOf(
        PropTypes.shape({
            nazwa: PropTypes.string,
            selected: PropTypes.string,
        })
    ),
    parentName: PropTypes.string,
    initState: PropTypes.object,
    disabled: PropTypes.bool,
};
